import type { PriceItem } from "@/types/content";

export const priceItems: PriceItem[] = [
  {
    id: "au9999",
    name: "上海金交所 Au9999",
    symbol: "Au99.99",
    category: "spot",
    market: "上海黄金交易所",
    price: 512.36,
    change: 3.42,
    changePercent: 0.67,
    open: 509.1,
    high: 514.02,
    low: 508.55,
    prevClose: 508.94,
    volume: 24560,
    unit: "元/克",
    updateTime: "2026-10-12 15:30",
    trend: [508.9, 509.4, 510.1, 509.7, 510.8, 511.5, 511.1, 512.0, 512.6, 512.1, 512.8, 512.36],
    tags: ["现货", "人民币计价", "主流品种"],
    summary:
      "上海黄金交易所 Au9999 是境内实物黄金定价的核心基准，日内跟随国际金价走强，成交量温和放大，短线维持高位震荡。",
    outlook:
      "短期受美元指数回落与避险情绪推动，若站稳 510 元/克支撑，有望进一步挑战前高；建议关注晚间美国经济数据对金价的影响。",
    relatedNewsIds: ["n1", "n5", "n8"],
  },
  {
    id: "gold-td",
    name: "黄金延期合约 Au(T+D)",
    symbol: "Au(T+D)",
    category: "spot",
    market: "上海黄金交易所",
    price: 513.88,
    change: 3.16,
    changePercent: 0.62,
    open: 510.9,
    high: 515.4,
    low: 510.2,
    prevClose: 510.72,
    volume: 38920,
    unit: "元/克",
    updateTime: "2026-10-12 15:30",
    trend: [510.7, 511.2, 511.9, 511.4, 512.3, 513.0, 512.6, 513.4, 514.1, 513.8, 514.3, 513.88],
    tags: ["延期交割", "保证金交易", "日内活跃"],
    summary:
      "黄金延期合约采用保证金机制，日内波动放大，持仓量稳步上行，多头氛围占据主导，适合具备风险承受能力的投资者参与。",
    outlook:
      "关注 515 元/克一带的压力，若放量突破可顺势跟进；跌破 510 元/克需警惕短线回调风险。",
    relatedNewsIds: ["n2", "n4", "n6"],
  },
  {
    id: "london-gold",
    name: "伦敦金现 (XAU/USD)",
    symbol: "XAUUSD",
    category: "spot",
    market: "伦敦金银市场协会",
    price: 2648.7,
    change: 16.4,
    changePercent: 0.62,
    open: 2632.8,
    high: 2655.6,
    low: 2630.1,
    prevClose: 2632.3,
    volume: 128400,
    unit: "美元/盎司",
    updateTime: "2026-10-12 15:30",
    trend: [2632.3, 2635.1, 2638.4, 2637.0, 2641.2, 2644.8, 2643.5, 2646.9, 2649.2, 2647.6, 2650.1, 2648.7],
    tags: ["国际现货", "全球基准", "美元计价"],
    summary:
      "伦敦金现是全球黄金定价的风向标，欧美盘交投活跃，金价重返 2650 美元上方，避险与降息预期共同构成支撑。",
    outlook: "上方关注 2660—2680 美元区间阻力，下方 2620 美元为短期多空分水岭。",
    relatedNewsIds: ["n1", "n4", "n9"],
  },
  {
    id: "paper-gold",
    name: "银行纸黄金 (人民币)",
    symbol: "PAPER-GOLD",
    category: "spot",
    market: "商业银行账户金",
    price: 512.05,
    change: 3.28,
    changePercent: 0.64,
    open: 508.9,
    high: 513.6,
    low: 508.2,
    prevClose: 508.77,
    volume: 15680,
    unit: "元/克",
    updateTime: "2026-10-12 15:30",
    trend: [508.8, 509.3, 510.0, 509.6, 510.6, 511.3, 510.9, 511.8, 512.4, 511.9, 512.6, 512.05],
    tags: ["银行渠道", "无杠杆", "门槛低"],
    summary:
      "纸黄金投资门槛低、无杠杆，适合以配置为目的的稳健型投资者，净值走势与实盘金价保持高度一致。",
    outlook: "作为长期配置工具，可采用分批买入策略平滑成本，避免追高。",
    relatedNewsIds: ["n2", "n6", "n7"],
  },
  {
    id: "comex-gold",
    name: "COMEX 黄金期货主力",
    symbol: "GC",
    category: "futures",
    market: "纽约商品交易所",
    price: 2669.4,
    change: 18.9,
    changePercent: 0.71,
    open: 2650.5,
    high: 2675.2,
    low: 2648.0,
    prevClose: 2650.5,
    volume: 96400,
    unit: "美元/盎司",
    updateTime: "2026-10-12 15:30",
    trend: [2650.5, 2653.8, 2657.1, 2655.4, 2660.2, 2663.9, 2662.1, 2665.6, 2668.4, 2667.0, 2670.3, 2669.4],
    tags: ["国际期货", "杠杆交易", "机构参与"],
    summary:
      "COMEX 黄金期货主力合约跟随现货走强，持仓与成交同步放大，市场对年内进一步降息的定价升温，多头情绪积极。",
    outlook: "若突破 2680 美元阻力，中期上行空间有望打开；反之或在 2640—2680 区间震荡整固。",
    relatedNewsIds: ["n1", "n5", "n9"],
  },
  {
    id: "shfe-au",
    name: "上海期货交易所 沪金主力",
    symbol: "AU2412",
    category: "futures",
    market: "上海期货交易所",
    price: 516.42,
    change: 3.72,
    changePercent: 0.73,
    open: 512.9,
    high: 518.1,
    low: 512.3,
    prevClose: 512.7,
    volume: 152300,
    unit: "元/克",
    updateTime: "2026-10-12 15:00",
    trend: [512.7, 513.4, 514.1, 513.6, 514.8, 515.5, 515.0, 515.9, 516.7, 516.2, 516.9, 516.42],
    tags: ["国内期货", "人民币计价", "主力合约"],
    summary:
      "沪金主力合约日内震荡走高，尾盘收于 516 元/克上方，内外盘价差维持稳定，产业与投资资金交投活跃。",
    outlook: "短线关注 518 元/克压力位，中期走势仍取决于国际金价与人民币汇率联动。",
    relatedNewsIds: ["n5", "n8", "n3"],
  },
  {
    id: "shfe-au-next",
    name: "上海期货交易所 沪金次主力",
    symbol: "AU2506",
    category: "futures",
    market: "上海期货交易所",
    price: 520.16,
    change: 3.54,
    changePercent: 0.69,
    open: 517.0,
    high: 521.8,
    low: 516.4,
    prevClose: 516.62,
    volume: 42300,
    unit: "元/克",
    updateTime: "2026-10-12 15:00",
    trend: [516.6, 517.3, 518.0, 517.5, 518.6, 519.4, 518.9, 519.7, 520.5, 520.0, 520.8, 520.16],
    tags: ["国内期货", "远月合约", "期限结构"],
    summary:
      "沪金远月合约相对近月维持小幅升水，反映出市场对中长期金价的乐观预期，远月持仓稳步增加。",
    outlook: "远月升水结构或延续，关注展期收益与资金成本变化对跨期价差的影响。",
    relatedNewsIds: ["n3", "n5", "n7"],
  },
  {
    id: "comex-gold-cont",
    name: "COMEX 黄金连续合约",
    symbol: "GC.C",
    category: "futures",
    market: "纽约商品交易所",
    price: 2667.1,
    change: 17.6,
    changePercent: 0.66,
    open: 2649.8,
    high: 2673.0,
    low: 2647.5,
    prevClose: 2649.5,
    volume: 71800,
    unit: "美元/盎司",
    updateTime: "2026-10-12 15:30",
    trend: [2649.5, 2652.6, 2656.0, 2654.2, 2658.9, 2662.5, 2660.8, 2664.1, 2667.0, 2665.6, 2668.9, 2667.1],
    tags: ["国际期货", "连续合约", "趋势参考"],
    summary:
      "连续合约平滑了换月跳空，便于观察中长期价格趋势，当前位于年内高位区间，多头排列结构清晰。",
    outlook: "趋势指标维持多头，回踩 2640 美元不破可继续持有，跌破需防范高位调整。",
    relatedNewsIds: ["n1", "n4", "n9"],
  },
];